// extracted by mini-css-extract-plugin
export default {"commentContainer":"Comment_commentContainer__Q9Jz8","author":"Comment_author__OEBCU","text":"Comment_text__XtANA","timestamp":"Comment_timestamp__aQsja"};